// src/hooks/utility/usePageTitle.ts

import { useLocation } from "react-router-dom";

// The title logic is now inside the hook itself. No separate file needed!
export const usePageTitle = () => {
  const location = useLocation();

  // A simple switch statement to get the title based on the path
  const getTitle = (path: string) => {
    switch (path) {
      case "/dashboard":
        return "Dashboard";
      case "/organisation/suivi-saisies":
        return "Suivi des saisies";
      case "/organisation/gestion-interne":
        return "Gestion interne";
      case "/data-entry":
        return "Saisie des Données";
      case "/carbon":
        return "Bilan Carbone";
      case "/esg":
        return "Indicateurs ESG";
      case "/data-analysis/customization":
        return "Customisation des données";
      case "/organisation":
        return "Organisation";
      default:
        return "Accueil"; // Default title
    }
  };

  const title = getTitle(location.pathname);

  return title;
};
